/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



// Klaviyo Back in stock for Complimentary products

(function () {
  var params = new URLSearchParams(window.location.search);
  if (!params.has('bis')) return;

  function tryOpenBIS() {
    // Most common container from your working HTML
    var btn = document.querySelector('#klaviyo-bis-button-container button');

    // Fallback: Klaviyo sometimes renders without the container id; use a11y identifier
    if (!btn) btn = document.querySelector('button[data-a11y-identifier^="bis-button"]');

    if (btn) {
      btn.click();

      // Clean URL so it doesn't re-open on refresh
      params.delete('bis');
      var newUrl =
        window.location.pathname +
        (params.toString() ? '?' + params.toString() : '') +
        window.location.hash;
      window.history.replaceState({}, '', newUrl);

      return true;
    }
    return false;
  }

  // Try immediately
  if (tryOpenBIS()) return;

  // Retry while Klaviyo injects
  var attempts = 0;
  var maxAttempts = 80; // ~8 seconds
  var timer = setInterval(function () {
    attempts++;
    if (tryOpenBIS() || attempts >= maxAttempts) clearInterval(timer);
  }, 100);
})();

(function () {
  var slideSelector = '[data-advanced-video-slide]';
  var sourceSelector = '[data-advanced-video-source]';

  function getVisibleSource(slide) {
    var sources = Array.prototype.slice.call(slide.querySelectorAll(sourceSelector));

    return sources.find(function (source) {
      return window.getComputedStyle(source).display !== 'none';
    }) || sources[0];
  }

  function postExternalCommand(source, command) {
    var wrapper = source && source.querySelector('.advanced-slideshow__external-video');
    var iframe = wrapper && wrapper.querySelector('iframe');
    if (!iframe || !iframe.contentWindow) return;

    if (wrapper.getAttribute('data-video-provider') === 'youtube') {
      iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: command === 'play' ? 'playVideo' : 'pauseVideo', args: [] }), '*');
    } else if (wrapper.getAttribute('data-video-provider') === 'vimeo') {
      iframe.contentWindow.postMessage(JSON.stringify({ method: command }), '*');
    }
  }

  function updateToggle(slide, playing) {
    var toggle = slide.querySelector('[data-advanced-video-toggle]');
    if (!toggle) return;

    var label = playing ? 'Pause video' : 'Play video';
    toggle.setAttribute('aria-pressed', playing ? 'true' : 'false');
    toggle.setAttribute('aria-label', label);

    var hiddenLabel = toggle.querySelector('[data-advanced-video-toggle-label]');
    if (hiddenLabel) hiddenLabel.textContent = label;
  }

  function pauseSource(source) {
    if (!source) return;

    var video = source.querySelector('video');
    if (video) video.pause();
    postExternalCommand(source, 'pause');
    source.setAttribute('data-video-playing', 'false');
  }

  function playSource(source) {
    if (!source) return;

    var poster = source.querySelector('.advanced-slideshow__video-poster');
    var iframe = source.querySelector('iframe[data-autoplay-src]');
    if (iframe && !iframe.getAttribute('src')) {
      iframe.setAttribute('src', iframe.getAttribute('data-autoplay-src'));
    }
    if (poster) poster.remove();

    var video = source.querySelector('video');
    if (video) {
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(function () {});
    }

    postExternalCommand(source, 'play');
    source.setAttribute('data-video-playing', 'true');
  }

  function syncSlide(slide) {
    var activeSource = getVisibleSource(slide);
    var sources = slide.querySelectorAll(sourceSelector);
    var isSelected = slide.classList.contains('is-selected');
    var shouldAutoplay = slide.getAttribute('data-video-autoplay') === 'true';

    Array.prototype.forEach.call(sources, function (source) {
      if (source !== activeSource || !isSelected) pauseSource(source);
    });

    if (isSelected && shouldAutoplay && slide.getAttribute('data-video-user-paused') !== 'true') {
      playSource(activeSource);
    }

    var isPlaying = isSelected && activeSource && activeSource.getAttribute('data-video-playing') === 'true';
    updateToggle(slide, isPlaying);
  }

  function syncAll(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll(slideSelector), syncSlide);
  }

  function initialiseSlide(slide) {
    if (slide.getAttribute('data-advanced-video-initialised') === 'true') return;
    slide.setAttribute('data-advanced-video-initialised', 'true');

    Array.prototype.forEach.call(slide.querySelectorAll('video'), function (video) {
      video.addEventListener('play', function () {
        var source = video.closest(sourceSelector);
        if (source) source.setAttribute('data-video-playing', 'true');
        updateToggle(slide, true);
      });
      video.addEventListener('pause', function () {
        var source = video.closest(sourceSelector);
        if (source) source.setAttribute('data-video-playing', 'false');
        if (source === getVisibleSource(slide)) updateToggle(slide, false);
      });
    });

    Array.prototype.forEach.call(slide.querySelectorAll('iframe'), function (iframe) {
      iframe.addEventListener('load', function () {
        var source = iframe.closest(sourceSelector);
        var shouldResume = source && source.getAttribute('data-video-playing') === 'true';
        var shouldAutoplay = slide.getAttribute('data-video-autoplay') === 'true' && slide.getAttribute('data-video-user-paused') !== 'true';

        if (slide.classList.contains('is-selected') && (shouldResume || shouldAutoplay)) {
          playSource(getVisibleSource(slide));
        } else {
          postExternalCommand(source, 'pause');
        }
      });
    });

    new MutationObserver(function (mutations) {
      if (mutations.some(function (mutation) { return mutation.attributeName === 'class'; })) {
        if (!slide.classList.contains('is-selected')) slide.removeAttribute('data-video-user-paused');
        syncSlide(slide);
      }
    }).observe(slide, { attributes: true, attributeFilter: ['class'] });

    syncSlide(slide);
  }

  function initialise(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll(slideSelector), initialiseSlide);
  }

  document.addEventListener('click', function (event) {
    var poster = event.target.closest('.advanced-slideshow__video-poster');
    var toggle = event.target.closest('[data-advanced-video-toggle]');
    if (!poster && !toggle) return;

    var slide = (poster || toggle).closest(slideSelector);
    var source = slide && getVisibleSource(slide);
    if (!slide || !source) return;

    event.preventDefault();
    event.stopPropagation();

    if (poster) {
      slide.setAttribute('data-video-user-paused', 'false');
      playSource(source);
      updateToggle(slide, true);
      return;
    }

    if (source.getAttribute('data-video-playing') === 'true') {
      slide.setAttribute('data-video-user-paused', 'true');
      pauseSource(source);
      updateToggle(slide, false);
    } else {
      slide.setAttribute('data-video-user-paused', 'false');
      playSource(source);
      updateToggle(slide, true);
    }
  });

  var mobileMedia = window.matchMedia('(max-width: 640px)');
  if (typeof mobileMedia.addEventListener === 'function') {
    mobileMedia.addEventListener('change', function () { syncAll(document); });
  } else if (typeof mobileMedia.addListener === 'function') {
    mobileMedia.addListener(function () { syncAll(document); });
  }

  document.addEventListener('shopify:section:load', function (event) { initialise(event.target); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialise(document); });
  } else {
    initialise(document);
  }
})();
